import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const MENU_ITEMS = [{
  label: 'about',
  path: '/'
}, {
  label: 'dinners',
  path: '/dinners'
}, {
  label: 'journals',
  path: '/journals'
}];
export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleNavigate = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };
  return <>
      {/* Hamburger Menu Button - Top Right */}
      <button onClick={() => setIsOpen(true)} className="md:hidden fixed top-4 right-4 z-40 flex flex-col gap-1.5 p-2" aria-label="Open menu" data-id="element-163">
        <div className="w-8 h-1 bg-white rounded-full" data-id="element-164" />
        <div className="w-8 h-1 bg-white rounded-full" data-id="element-165" />
        <div className="w-8 h-1 bg-white rounded-full" data-id="element-166" />
      </button>

      {/* Half Screen Overlay Menu - Right Side Only */}
      {isOpen && <div className="md:hidden fixed inset-y-0 right-0 w-[60%] z-50 bg-[#C5D9D9] border-l-2 border-black flex flex-col items-center justify-center p-6" data-id="element-167">
          {/* Close Button - Top Right */}
          <button onClick={() => setIsOpen(false)} className="absolute top-6 right-6 p-2" aria-label="Close menu" data-id="element-168">
            <X size={40} strokeWidth={2} color="#2D4A4F" data-id="element-169" />
          </button>

          {/* Menu Items */}
          <nav className="flex flex-col gap-3 w-full" data-id="element-170">
            {MENU_ITEMS.map(item => <button key={item.label} onClick={() => handleNavigate(item.path)} className="w-full py-4 px-5 bg-white border-2 border-black rounded-2xl text-center text-base font-bold transition-transform active:scale-95 uppercase" style={{
          fontFamily: "'Space Mono', monospace"
        }} data-id="element-171">
                {item.label}
              </button>)}
          </nav>
        </div>}
    </>;
}